import React from 'react';
import { Card, Typography } from 'antd';

const { Title, Paragraph } = Typography;

const IframePage: React.FC = () => {
  return (
    <div style={{ height: 'calc(100vh - 112px)' }}>
      <Card 
        // title="外部页面" 
        style={{ height: '100%' }}
        bodyStyle={{ height: 'calc(100% - 57px)', padding: 0 }}
      >
        <iframe
          src="https://share.tcbi.qq.com/page/share?pageId=10555804&projectId=11042899&token=1b9fe8da-b4a4-46e2-a0d2-a33353886d57&scope=page&canvasType=GRID"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: '6px'
          }}
          title="外部页面"
        />
      </Card>
    </div>
  );
};

export default IframePage;